import React, { useCallback, useEffect, useState } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput, Avatar, InputBase, SvgIcon } from "@material-ui/core"
import { Flow } from './';
import { makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import abmActions from "../../../redux/actions/abm.actions";
import { ReactFlowProvider, useStoreState } from "react-flow-renderer";
import { useSnackContext } from "../../contexts/Snack";
import { FlowProvider, useFlowContext } from "../../contexts/Flow";
import Swal from 'sweetalert2';

const useStyles = makeStyles(theme => {
  return {
    formControl: {
      minWidth: 120,
    },
    divColor: {
      minWidth: 120,
      width: "100%",
      maxWidth:"50px",
      padding: theme.spacing(1),
      margin: theme.spacing(1),
      borderRadius: "4px",
    },
    icon: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      maxWidth: theme.spacing(3),
      maxHeight: theme.spacing(3),
    },
  
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      maxWidth: theme.spacing(4),
      maxHeight: theme.spacing(4),
      cursor: "pointer",
    },
    pre: {
      color: "white !important",
    }

  }
});


export const FlowControlOqt = (props) => {
  return (
    <FlowProvider>
      <ReactFlowProvider>
        <ChildFlowControlOqt {...props}/>
      </ReactFlowProvider>
    </FlowProvider>
  )
}

 const ChildFlowControlOqt = React.memo(({details = false, size, name, caption, formik, variant = "outlined"}) => {

  const [ open, setOpen ] = useState(false);
  const snack = useSnackContext();
  const { flowData } = useFlowContext();
  const dispatch = useDispatch();
  const [ loading, setLoading ] = useState(true);
  const classes = useStyles();


  const InputCode = variant === "standard" ? InputBase : OutlinedInput;

  const disabled = !formik || !formik.values.id || formik.values.id === 0;
  


  const handleFlowLoaded = () => {
    setLoading(false);
  }

  const handleInputChange = useCallback(({close = true}) => {   
    //console.log(flowData)
    if(!flowData) return;
    const postFlow = (idOperacion, data) => dispatch(abmActions().postFlow(idOperacion, data));
    setLoading(true)
    //console.log(flowData.get())
    postFlow(formik.values.id, flowData.get())
      .then(response => {
        snack.openSuccess("El flujo se guardó correctamente.");
        if (close) handleClose({check: false});  
      })
      .catch(error => {
        snack.openAxiosError(error);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [formik.values, flowData, snack, dispatch])
  

  const handleClose = ({check = true}) => {
    if(!flowData || !flowData.isChanged || !check){
      setOpen(false); 
      return
    }
    Swal
      .fire({
        icon: 'question',
        title: 'Cerrar?',
        html: `Está a punto de cerrar este flujo sin guardar cambios, precione cerrar para confirmar y salir sin guardar`,
        showCancelButton: true,
        confirmButtonText: 'Cerrar',
        cancelButtonText: 'Continuar editando',
      })
      .then((result) => {
        if (result.isConfirmed) {
          setOpen(false); 
        }
      })
  }

  const handleOpen = (event) => {
    event.preventDefault();
    if(!disabled && !details){
      setLoading(true)
      setOpen(true);
    } 
  }

  return (

    <div style={{ padding: 8, width:"100%" }}>
      <FormControl disabled={disabled} fullWidth variant={variant} className={classes.formControl}  onClick={handleOpen} >
        {variant === "oulined" &&
          <InputLabel>
            {caption}
          </InputLabel>
        }
        <InputCode 
          disabled={disabled}
          size={size}
          readOnly={true}
          type="text" 
          endAdornment={
            <InputAdornment position="end" disabled={disabled}>
              <Avatar className={classes.avatar} style={{backgroundColor: "#bdbdbd", width:24, height:24, padding: 0}} >
                <NodesIcon style={{width:16, height:16, fill:"black"}}/>
              </Avatar>
            </InputAdornment>
          }
          value={disabled ? "Guarde para editar el flujo" : "Ingrese al flujo para editarlo"}
          label={caption}
          onClick={handleOpen}
          style={
            variant === "standard" ? {        
              border: "0px solid white",
              borderBottom: "0px solid #949494",
              borderRadius: "0px",
              cursor: "pointer"
            } : {
              cursor: "pointer"
            }
          }
        />
      </FormControl>
      <Dialog open={open}  aria-labelledby="form-dialog-title" onClose={handleClose} fullScreen>
        <DialogTitle id="form-dialog-title">{caption} - {formik.values.nombre}</DialogTitle>
        <DialogContent>
          <Flow formik={formik} name={name} onLoad={handleFlowLoaded} onSave={handleInputChange} onClose={handleClose}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>Cerrar</Button>
          <Button onClick={handleInputChange} disabled={loading}>Aceptar</Button>
        </DialogActions>
      </Dialog>
    </div>

  )
})

const NodesIcon = ({style}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" style={style}><path d="M 6 2 A 1.0001 1.0001 0 0 0 5 3 L 5 13 A 1.0001 1.0001 0 0 0 6 14 L 22 14 A 1.0001 1.0001 0 0 0 23 13 L 23 3 A 1.0001 1.0001 0 0 0 22 2 L 6 2 z M 7 4 L 21 4 L 21 12 L 7 12 L 7 4 z M 13 16 L 13 42 A 1.0001 1.0001 0 0 0 14 43 L 25 43 L 25 41 L 15 41 L 15 26 L 25 26 L 25 24 L 15 24 L 15 16 L 13 16 z M 28 19 C 27.447 19 27 19.448 27 20 L 27 30 C 27 30.552 27.447 31 28 31 L 44 31 C 44.553 31 45 30.552 45 30 L 45 20 C 45 19.448 44.553 19 44 19 L 28 19 z M 28 36 C 27.447 36 27 36.448 27 37 L 27 47 C 27 47.552 27.447 48 28 48 L 44 48 C 44.553 48 45 47.552 45 47 L 45 37 C 45 36.448 44.553 36 44 36 L 28 36 z"></path></svg>
}